module.exports = __webpack_public_path__ + "img/cl_login_logo.8d6235bc.png";